/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 7/25/13
 * Time: 6:53 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var WebAgentMainLayout = require("web-agent-views/WebAgentMainLayout");
    var BaseRouterController = require("controllers/BaseRouterController");
    var WebAgentRouteController;

    LE.module("LEWebAgent", function (LEWebAgent) {
        WebAgentRouteController = BaseRouterController.extend({

            initialize:function () {
                this.webAgentLayout = new WebAgentMainLayout();
            },

            //define your route/handler map here
            //all handlers must be defined in this file
            navigation: {
                routes:{
                    "webagent":{
                        name: 'webagent',
                        callback: "routeHandler",
                        auth: {
                            privileges: []
                        }
                    }
                },
                defaultRoute:"webagent"
            },

            //handler definitions
            routeHandler:function () {
                // TODO: Do resume webagent here.
            },
            getMainView:function () {
                return this.webAgentLayout;
            }
        });
    });

    return WebAgentRouteController;
});
